import { useState, useEffect } from 'react';

import { getFromStore, setToStore } from '../store';

const storeKey = 'compliance-cookiebanner-dismissed';

export default function useDismiss() {
  const [dismissed, setDismissed] = useState(getFromStore(storeKey, false));

  useEffect(() => {
    setToStore(storeKey, dismissed);
  }, [dismissed]);

  const onDismiss = () => {
    setDismissed(true);
  };

  return [dismissed, onDismiss];
}
